// export const BASE_URL = 'http://127.0.0.1:8001//';
export const PROJECTNAME = 'PhleboIndia';

